import React from "react";
import ReactDom from "react-dom";
import DynamicLeadershipListingApp from "./DynamicLeadershipListingApp.jsx";

export default function renderDynamicLeadershipListingApp() {
  document
    .querySelectorAll(".js-dynamic-leadership-listing-mount")
    .forEach((mount, i) => {
      const dictionary = JSON.parse(mount.dataset.dictionary) || null;
      const query = JSON.parse(mount.dataset.query) || {};
      const dataModel = JSON.parse(mount.dataset.model);
      const showQueryStrings =
        dataModel.enableQueryString &&
        !document.querySelector("body.is-page-editor");

      ReactDom.render(
        <DynamicLeadershipListingApp
          dictionary={{ ...dictionary }}
          query={query}
          id={`dynamic-leadership-listing-${i}`}
          {...dataModel}
          enableQueryString={showQueryStrings}
        />,
        mount,
      );
    });
}
